gsap.registerPlugin(ScrollToPlugin);
const mm = gsap.matchMedia();

// Fade Animations for every page
var fadeInElems = gsap.utils.toArray(".fade.fadeIn");
fadeInElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        ease: 'sine.out',
        duration: 2,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeUpElems = gsap.utils.toArray(".fade.fadeUp");
fadeUpElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        y: 15,
        ease: 'sine.out',
        duration: 2,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeLeftElems = gsap.utils.toArray(".fade.fadeLeft");
fadeLeftElems.forEach(function(elem) {
    mm.add("(min-width: 769px)", () => {
        gsap.from(elem, {
            autoAlpha: 0,
            x: -15,
            ease: 'sine.out',
            duration: 1,
            scrollTrigger: {
                trigger: elem,
                start: "top 75%"
            }    
        })
    })
    mm.add("(max-width: 768px", () => {
        gsap.from(elem, {
            autoAlpha: 0,
            ease: 'sine.out',
            duration: 2,
            scrollTrigger: {
                trigger: elem,
                start: "top 75%"
            }    
        })
    })
})

var fadeRightElems = gsap.utils.toArray(".fade.fadeRight");
fadeRightElems.forEach(function(elem) {
    mm.add("(min-width: 769px)", () => {
        gsap.from(elem, {
            autoAlpha: 0,
            x: 15,
            ease: 'sine.out',
            duration: 1,
            scrollTrigger: {
                trigger: elem,
                start: "top 75%"
            }    
        })
    })
    mm.add("(max-width: 768px", () => {
        gsap.from(elem, {
            autoAlpha: 0,
            ease: 'sine.out',
            duration: 2,
            scrollTrigger: {
                trigger: elem,
                start: "top 75%"
            }    
        })
    })
})

window.initFrameworkParentAnims = function () {
    const indicator = document.querySelector(".scroll-spy .scroll-spy-wrapper .indicator");
    const topFrameworks = gsap.utils.toArray(".children-wrapper .children-items > div");

    topFrameworks.forEach((item, index) => {
        const i = index + 1;
        gsap.to(indicator, {
            width: (100 / topFrameworks.length) * i + "%",
            immediateRender: false,
            ease: 'none',
            scrollTrigger: {
                trigger: item,
                start: "top +240",
                end: "bottom +240",
                scrub: true,
                onEnter: () => {
                    // console.log(`Entering #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.add('active');
                },
                onLeave: () => {
                    // console.log(`Leaving #group-${i}`);
                    // document.querySelector(`#scroll_spy_item_${i}`).classList.remove('active');
                },
                onEnterBack: () => {
                    // console.log(`Entering #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.add('active');
                },
                onLeaveBack: () => {
                    // console.log(`Leaving #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.remove('active');
                }
                // markers: true,
                // id: `#group-${i}`
            }
        })
    })
}

window.initFrameworkSingleAnims = function () {
    const indicator = document.querySelector(".scroll-spy .scroll-spy-wrapper .indicator");
    const sections = gsap.utils.toArray(".section");

    sections.forEach((item, index) => {
        const i = index + 1;
        gsap.to(indicator, {
            width: (100 / sections.length) * i + "%",
            immediateRender: false,
            ease: 'none',
            scrollTrigger: {
                trigger: item,
                start: "top +195",
                end: "bottom +195",
                scrub: true,
                onEnter: () => {
                    // console.log(`Entering #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.add('active');
                },
                onLeave: () => {
                    // console.log(`Leaving #group-${i}`);
                    // document.querySelector(`#scroll_spy_item_${i}`).classList.remove('active');
                },
                onEnterBack: () => {
                    // console.log(`Entering #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.add('active');
                },
                onLeaveBack: () => {
                    // console.log(`Leaving #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.remove('active');
                },
                // markers: true,
                // id: `#group-${i}`
            }
        })
    })
}

window.initHowWeCanHelpAnims = function () {
    const indicator = document.querySelector(".scroll-spy .scroll-spy-wrapper .indicator");
    const scrollSpySections = gsap.utils.toArray(".scroll-spy-section");

    scrollSpySections.forEach((item, index) => {
        const i = index + 1;
        gsap.to(indicator, {
            width: (100 / scrollSpySections.length) * i + "%",
            immediateRender: false,
            ease: 'none',
            scrollTrigger: {
                trigger: item,
                start: "top +240",
                end: "bottom +240",
                scrub: true,
                onEnter: () => {
                    // console.log(`Entering #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.add('active');
                },
                onLeave: () => {
                    // console.log(`Leaving #group-${i}`);
                    // document.querySelector(`#scroll_spy_item_${i}`).classList.remove('active');
                },
                onEnterBack: () => {
                    // console.log(`Entering #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.add('active');
                },
                onLeaveBack: () => {
                    // console.log(`Leaving #group-${i}`);
                    document.querySelector(`#scroll_spy_item_${i}`).classList.remove('active');
                }
                // markers: true,
                // id: `#group-${i}`
            }
        })
    })
}
